import { render, staticRenderFns } from "./DashboardUserService.vue?vue&type=template&id=65d2785c&scoped=true"
import script from "./DashboardUserService.vue?vue&type=script&lang=ts"
export * from "./DashboardUserService.vue?vue&type=script&lang=ts"
import style0 from "./DashboardUserService.vue?vue&type=style&index=0&id=65d2785c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d2785c",
  null
  
)

export default component.exports